import { Grid } from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  CancelButton,
  PrimaryLoadingButton,
} from "../../../pages/css components/Button";
import { Paper } from "../../../components";
import { colors } from "../../../pages/css components/Style";
import { alert } from "../../../redux/slices/alertSlice";

export default function AudienceButtons({
  ID = "",
  disabled = false,
  editState,
  setEditState,
  formikProps,
  route = "",
  messages,
  state,
  disaptchMessage,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  async function handleOnSubmit() {
    if (!state.audience_group?.value) {
      let message = {
        audience_group: "Audience Group must be at least 3 characters",
      };

      disaptchMessage({
        type: "MESSAGE_UPDATE",
        payload: { value: message, key: "audience_group.value" },
      });

      dispatch(
        alert({
          type: "error",
          message: "Audience name is mandatory.",
        })
      );

      return;
    }
    if (Object.keys(state).length === 7 && state.audience_group?.value) {
      dispatch(
        alert({
          type: "error",
          message: "Atleast One field should be filled for creating audience.",
        })
      );

      return;
    }

    if (Object.keys(messages).length > 0) {
      dispatch(
        alert({
          type: "error",
          message: "Please fix the errors first",
        })
      );

      return;
    }

    formikProps.handleSubmit();
  }
  return (
    <Paper style={{ background: colors.hoverBlue, padding: "13px" }}>
      <Grid size="auto" offset={{ xs: "auto" }} />

      {!editState && (
        <Grid size="auto">
          <CancelButton variant="outlined" onClick={() => navigate(-1)}>
            Back
          </CancelButton>
        </Grid>
      )}

      {!!editState && (
        <Grid size="auto">
          <PrimaryLoadingButton
            type="submit"
            variant="contained"
            fullWidth
            onClick={handleOnSubmit}
            disabled={disabled}
            loading={formikProps.isSubmitting}
            color="primary"
          >
            Submit
          </PrimaryLoadingButton>
        </Grid>
      )}

      {!!editState && (
        <Grid item>
          <CancelButton
            variant="outlined"
            disabled={formikProps.isSubmitting}
            onClick={() => {
              if (editState && !!ID) {
                setEditState(!editState);
                formikProps.handleReset();
              }
              if (!!route) {
                navigate(-1, { state: route });
              } else {
                navigate(-1);
              }
            }}
          >
            Cancel
          </CancelButton>
        </Grid>
      )}
    </Paper>
  );
}
